import { Spin } from "antd";
import { useState } from "react";
import { UseApiCallV2 } from "hooks";
import { OnCollapseIcon } from "pages/m2c-simulation/icons";
import {
  DraggableContext,
  SupportTicketsHeader,
  TicketsSearchFilter,
} from "./components";
import { ConditionalRenderer } from "components";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styles from "./styles.module.scss";
import { UseApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-api-call";

export function SupportTicketsV2() {
  const [searchVal, setSearchVal] = useState<string>("");
  const [expanded, setExpanded] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedIssueType, setSelectedIssueType] = useState("all");

  const {
    data: ticketsData,
    isLoading,
    refetch: refetchTicketsData,
  }: any = UseApiCallV2({
    url: "/get_all_tickets",
    method: "POST",
    paramsData: {
      token: "null",
    },
  });

  const { data: allTickets, isLoading: ticketsLoading } =
    UseApiCallInternalDashboard({
      isCvUser: false,
      url: "support/tickets",
      method: "POST",
      // body: {
      //   today: true,
      // },
    });

  let tickets = ticketsData;
  const handleChangeAccordian =
    (panel: any) => (event: any, isExpanded: any) => {
      setExpanded(isExpanded ? panel : "");
    };
  if (searchVal) {
    tickets = tickets?.filter((item: any) =>
      item.topic?.toLowerCase().includes(searchVal)
    );
  }

  if (selectedStatus !== "all" && Array.isArray(tickets)) {
    tickets = tickets?.filter((item: any) => item.status === selectedStatus);
  }
  if (selectedIssueType !== "all" && Array.isArray(tickets)) {
    tickets = tickets?.filter(
      (item: any) => item.issueType === selectedIssueType
    );
  }
  function getFilteredTickets({ totalTickets, key }: any) {
    return totalTickets?.filter((item: any) => item.sportsName === key);
  }

  const golfTickets = getFilteredTickets({
    totalTickets: tickets,
    key: "golf",
  });
  const baseballTickets = getFilteredTickets({
    totalTickets: tickets,
    key: "baseball",
  });
  const athleticsTickets = getFilteredTickets({
    totalTickets: tickets,
    key: "athletics",
  });

  function handleChangeTicketPreference(data: any) {
    setSelectedStatus(data?.value);
  }
  function handleChangeIssueType(data: any) {
    setSelectedIssueType(data?.value);
  }

  return (
    <section className={styles.supportTickets}>
      <ConditionalRenderer condition={isLoading}>
        <div className={styles.loading}>
          <Spin />
        </div>
      </ConditionalRenderer>

      <TicketsSearchFilter
        setSearchVal={setSearchVal}
        searchVal={searchVal}
        handleChangeTicketPreference={handleChangeTicketPreference}
        handleChangeIssueType={handleChangeIssueType}
      />
      <ConditionalRenderer condition={tickets}>
        <DraggableContext
          tickets={tickets}
          refetchTicketsData={refetchTicketsData}
        />
      </ConditionalRenderer>
    </section>
  );
}
